<template>
  <TipMatchPopupContainer
    :is-showpopup-close="isShowpopupClose"
    popup-title="提示"
    popup-class="tip-match-status-wrap"
    @onCancel="dismissDialog"
  >
    <div class="tip-match-status-info">
      <template v-if="matchStatus">
        <div class="tip-match-icon" />
        <p class="tip-match-status">
          {{ paySuccess.statusDesc }}
        </p>
        <p class="tip-match-desc">
          {{ paySuccess.tipDesc }}
        </p>
        <div
          class="tip-match-btn"
          @click="onSucCallback"
        >
          {{ paySuccess.btnDesc }}
        </div>
      </template>

      <template v-else>
        <p class="tip-match-status">
          游戏礼包待支付
        </p>
        <p class="tip-match-desc">
          支付遇到问题请重试。<span>{{ payFail.failCountDown }}</span>内不支付将自动删除游戏礼包，您也可后续补充礼包，支付前游戏礼包将不对外展示。
        </p>
        <div class="tip-match-btn-wrap">
          <div
            class="tip-match-del"
            @click="onDelete()"
          >
            删除游戏礼包
          </div>
          <div
            class="tip-match-confirm"
            @click="onRepay()"
          >
            <p>重新支付{{ payFail.failCountDown }}</p>
          </div>
        </div>
      </template>
    </div>
  </TipMatchPopupContainer>
</template>
<script>
import TipMatchPopupContainer from '@tencent/press-ui/press-popup/press-popup';
export default {
  components: {
    TipMatchPopupContainer,
  },
  props: {
    matchStatus: {
      type: Boolean,
      default: true,
    },
    // 成功描述
    paySuccess: {
      type: Object,
      default: () => ({
        statusDesc: '支付成功',
        tipDesc: '比赛结束后发放奖励，记得手动确认发奖或调整奖品哦',
        btnDesc: '我知道了（3）',
      }),
    },
    payFail: {
      type: Object,
      default: () => ({
        failCountDown: '23:59',
      }),
    },
  },
  options: {
    virtualHost: true,
  },
  data() {
    return {
      isShowpopupClose: true,
    };
  },
  mounted() {
  },
  methods: {
    dismissDialog() {
      this.$emit('dismissDialog');
    },
    confirm() {
      this.$emit('confirm');
    },
    onSucCallback(...args) {
      this.$emit('onSucCallback', ...args);
    },
    onDelete(...args) {
      this.$emit('onDelete', ...args);
    },
    onRepay(...args) {
      this.$emit('onRepay', ...args);
    },
  },
};

</script>
<style lang="scss" scoped src="./css/index.scss"></style>
